import { ComponentType } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarModel } from '@libs/common/models';
import { CepStateService } from '../cep-state';
import { FLASH_MESSAGE_COMPONENT_TYPE, FlashMessages, FlashMessageType } from './flash-message.model';

@Injectable({ providedIn: 'root' })
export class FlashMessageService {
  private readonly cepStateService: CepStateService = inject(CepStateService);
  private readonly snackbar: MatSnackBar = inject(MatSnackBar);
  private readonly componentCtr: ComponentType<unknown> = inject(FLASH_MESSAGE_COMPONENT_TYPE);

  public showMessage(type: FlashMessageType): void {
    this.showSnackbar(FlashMessages[type]);
  }

  public showCustomMessage(data: SnackbarModel): void {
    this.showSnackbar(data);
  }

  private showSnackbar(data: SnackbarModel): void {
    this.snackbar.openFromComponent(this.componentCtr, {
      data,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: this.cepStateService.hideScannerFAB() ? 'snackbar-without-fab' : 'snackbar-with-fab',
    });
  }
}
